module.exports = {
	number: {
		dependentFields: [],
		formulate: ({ id }) => {
			return id ? undefined : Math.floor(Math.random() * 10000);
		}
	}
};
